import { render } from "./SettingTabItem.vue?vue&type=template&id=cda44a1e&ts=true"
import script from "./SettingTabItem.vue?vue&type=script&lang=ts"
export * from "./SettingTabItem.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Settings/SettingTabItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cda44a1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cda44a1e', __exports__)) {
    api.reload('cda44a1e', __exports__)
  }
  
  module.hot.accept("./SettingTabItem.vue?vue&type=template&id=cda44a1e&ts=true", () => {
    api.rerender('cda44a1e', render)
  })

}


export default __exports__